/**
 * O seletor de período do Início e da Visão geral (2026-10-19): 1, 7, 15
 * ou 30 dias, contados até o dia do último dado. A escolha é lembrada no
 * navegador e é a MESMA nas duas telas (uma chave só), senão o mesmo
 * número apareceria com dois tamanhos de janela. Conveniência, não estado:
 * sem storage (aba privada) volta aos 30 dias.
 */

import { useState, type ReactNode } from "react";

import {
  DEFAULT_SUMMARY_PERIOD,
  SUMMARY_PERIODS,
  summaryPeriodLabel,
  type SummaryPeriod
} from "@/shared/utils/summary-window";

const STORAGE_KEY = "reputaition.summary_days";

function readStored(): SummaryPeriod {
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    return (SUMMARY_PERIODS as readonly number[]).includes(stored)
      ? (stored as SummaryPeriod)
      : DEFAULT_SUMMARY_PERIOD;
  } catch {
    return DEFAULT_SUMMARY_PERIOD;
  }
}

export function useSummaryDays(): [SummaryPeriod, (days: SummaryPeriod) => void] {
  const [days, setDays] = useState<SummaryPeriod>(readStored);
  const choose = (next: SummaryPeriod) => {
    setDays(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // Storage bloqueado: a escolha vale só nesta visita.
    }
  };
  return [days, choose];
}

export function SummaryPeriodPicker({
  days,
  onChange,
  disabled = false,
  children
}: {
  /** `null` = nenhuma das opções vale (a lista de menções aceita datas
   *  digitadas à mão). */
  days: SummaryPeriod | null;
  onChange: (days: SummaryPeriod) => void;
  disabled?: boolean;
  /** Botões extras no fim do grupo ("Todo o período", na lista). */
  children?: ReactNode;
}) {
  return (
    <div className="mentions-view-toggle summary-period-picker" role="radiogroup" aria-label="Período dos indicadores">
      {SUMMARY_PERIODS.map(option => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={option === days}
          className={option === days ? "active" : ""}
          disabled={disabled}
          onClick={() => onChange(option)}
        >
          {summaryPeriodLabel(option)}
        </button>
      ))}
      {children}
    </div>
  );
}
